import { useState } from 'react'
import { friendsService } from '../services/friendsService'

export const useFriendsSearch = () => {
  const [searchResults, setSearchResults] = useState([])
  const [searchLoading, setSearchLoading] = useState(false)

  const searchUsers = async (query) => {
    if (!query.trim()) return { success: false, error: 'Please enter a search term' }

    setSearchLoading(true)
    try {
      const data = await friendsService.searchUsers(query.trim())
      setSearchResults(data.users || [])
      return { success: true, users: data.users || [] }
    } catch (error) {
      if (process.env.NODE_ENV === 'development') console.error('Error searching users:', error)
      return { success: false, error: 'Failed to search users' }
    } finally {
      setSearchLoading(false)
    }
  }

  return {
    searchResults,
    searchLoading,
    searchUsers,
    setSearchResults
  }
}